import React from "react";
import MultiSelect from "./partials/MultiSelect";
import Sort from "./partials/Sort";
import TimeWindow from "./partials/TimeWindow";
import Sections from "./partials/Sections";
import Label from "./partials/Label";
import {IGridConfigItem} from "../../../constants/interfaces";
import Tags from "./partials/Tags";

type Props = {
	item: IGridConfigItem,
	updateConfig: Function,
	isEdit: boolean,
	removeItem: React.MouseEventHandler<HTMLButtonElement>,
	id: number
}

const VideoList = (props: Props) => {
    return (
        <div className="config-item__list">
            <h2>Video list</h2>
            <MultiSelect
				updateConfig={props.updateConfig}
				selectedColumns={props.item.fields}
				type="video_list"
				brands={props.item.brands}
				isEdit={props.isEdit}
			/>
            <Sort 
				updateConfig={props.updateConfig} 
				value={props.item.sort} 
				isVideo={true}
			/>

			<div className="config-item__selects">
				<TimeWindow updateConfig={props.updateConfig} timeWindow={props.item.time_window} />
			</div>
			
			<Sections
				updateConfig={props.updateConfig}
				sections={props.item.sections}
				brands={props.item.brands}
				type="videos"
				isEdit={props.isEdit}
				cellId={props.item.cell_id}
				id={props.id}
			/>

			<div className="config-item__selects">
				<Tags
					updateConfig={props.updateConfig}
					tags={props.item.tags}
					brands={props.item.brands}
					type="videos"
					isEdit={props.isEdit}
					isDisabled={props.item.brands.length === 0}
					cellId={props.item.cell_id}
					id={props.id}
				/>
			</div>
			
			<Label updateConfig={props.updateConfig} value={props.item.label}/>
            <button
                className="btn btn-outline-danger remove-item"
                onClick={props.removeItem}
            >
                Remove
            </button>
        </div>
    );
}

export default VideoList;
